module.exports = __webpack_public_path__ + "static/images/containers/ShopView/images/big/package_l.27190009.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/images/big/package_l.png
// module id = 992
// module chunks = 16